<template>
    <v-container>
    <div class="products">
        <v-row align="center" justify="center" id="products" v-if="payments.length === 0">
        <v-card
            
            class="mx-auto"
            max-width="100%"
            width="900px"
            color="primary"
            title="No payment"     
        ></v-card>
        </v-row>

      <v-row align="center" justify="center" id="products" v-else> 
        <v-col
          v-for="(payments, payment) in payments"
          :key="payment"
          cols="auto"
          
        >
          <v-card
            class="mx-auto"
            max-width="100%"
            width="900px"
            color="primary"
            
          >
            <v-card-item>
              <div>
                <div class="text-overline mb-1">
                    {{ payments.invoiceId }}
                </div>


                <div class="text-caption">Description: {{payments.description}} <br> Price: {{ payments.amountPaid/100}} {{ payments.currency}}<br>Date: {{ payments.paymentDate}}</div>
              </div>
            </v-card-item>

          </v-card>
        </v-col>
      </v-row>
    </div>
    </v-container>
    
  </template>
<style>
#products {
  margin-top: 20%;
}

.products{
    display: flex;
    align-items: center; 
    justify-content: center;
    height: 96vh;  
  }
@media only screen and (min-width: 600px) {

}
</style>

<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return {
          isAuthentified: localStorage.getItem('Authorization') !== null,
          payments : []
        };
    },
    created() {
      this.getPayments();
    },  

    computed: {
      ...mapGetters(['backend']),
    },

    methods: {
      async getPayments(){
        const token = localStorage.getItem("Authorization");
        const payments = await this.$axios.get(`${this.backend}/api/user/payments`, {headers: {"Authorization": token}})
        this.payments = payments.data
      },
    },
}

</script>